import React, { useEffect } from "react";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import Scaffold from "../../../widget/layouts/Scaffold";
import ImageDocumentPreviewContent from "./ImageDocumentPreviewContent";
import { MainBodyContainer } from "../../../widget/common/ui/MainContainer";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import ImageDocumentPreviewActions from "./widget/ImageDocumentPreviewActions";
import AppConfigService from "../../../service/app_config/AppConfigService";
import Div from "../../../widget/common/ui/Div";

const ImageDocumentPreviewScreen = (props: { screenMobileView?: boolean }) => {
  const type: number = ResponsiveDeviceType();
  const screenMobileView: boolean = props.screenMobileView ?? false;

  useEffect(() => {
    AppConfigService.init();
  }, []);

  return (
    <Scaffold
      appBarTitle={AppTranslation.text("preview")}
      appBarAction={<ImageDocumentPreviewActions isModal={false} />}
      isModal={screenMobileView}
    >
      {type === 1 ? (
        <Div className="h-100 p-0">
          <ImageDocumentPreviewContent type={type} isModal={false} />
        </Div>
      ) : (
        <MainBodyContainer className="h-100 p-0">
          <ImageDocumentPreviewContent type={type} isModal={false} />
        </MainBodyContainer>
      )}
    </Scaffold>
  );
};

export default ImageDocumentPreviewScreen;
export const routeName: string = "/image-document-preview";
